<template>
  <div class="modal fade in modal-active">
    <div class="modal-dialog" :class="{'modal__custom': isClassModalCustom}">
      <div class="modal-content">
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isClassModalCustom: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped>
.modal-dialog {
  padding-top: 50px;
  max-width: 700px;
}

.modal__custom {
  max-width: 100%;
}

.modal-active{
  display:block;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
}

.fade:not(.show) {
  opacity: 1;
}

.modal-body {
  background-color: #ececef8c;
}

@media (max-width: 768px) {
  .modal-dialog {
    max-width: 600px;
  }
  .modal-body {
    padding: 1rem .6rem;
  }
}

</style>
